import "./BoltAlert.scss";

import { Button, Flex, Text } from "@fluentui/react-northstar";

import { PollyIcon } from "../../components/PollyIcon";
import { useTeamsContext } from "../../state/TeamsContextProvider";
import { isMobileClient } from "../../utils/clientHelper";

type BoltAlertProps = {
  onButtonClick?: () => void;
  buttonCta?: string;
  prompt: string;
  showButton: boolean;
};

export const BoltAlert: React.FC<BoltAlertProps> = ({
  onButtonClick,
  buttonCta,
  prompt,
  showButton,
}) => {
  const { teamsContext } = useTeamsContext();
  return (
    <Flex className="change-plan-prompt" gap="gap.small">
      <Flex className="text-and-icon" gap="gap.small">
        <Flex className="bolt-icon">
          <PollyIcon inheritColor icon="bolt" />
        </Flex>
        <Text content={prompt} />
      </Flex>
      {showButton && (
        <Button
          primary
          onClick={onButtonClick}
          icon={<PollyIcon icon="plus-outlined" inheritColor />}
          content={buttonCta}
          iconOnly={isMobileClient(teamsContext)}
        />
      )}
    </Flex>
  );
};
